import styled from "styled-components"
import { MEDIA_QUERIES } from "@constants"

export const PostAuthorsDIV = styled.div`
  align-items: center;
  color: var(--color--text-light);
  display: flex;
  flex-wrap: wrap;
  font-size: var(--font-size--S);
  justify-content: center;
  margin: 0 auto var(--spacing--M);

  a {
    color: inherit;

    &:hover {
      color: var(--color--action-hovered);
    }
  }

  .AvatarsRow {
    margin-right: var(--spacing--base-0-5);
  }

  .divider {
    display: none;
    color: var(--color--clay-400);
    margin: 0 6px;
  }

  .date {
    flex: 0 0 100%;
    text-align: center;
    margin: 10px 0 0;
  }

  ${MEDIA_QUERIES.S} {
    .divider {
      display: inline-block;
    }

    .date {
      flex: none;
      margin: 0;
      text-align: left;
    }
  }
`
